module.exports = __webpack_public_path__ + "img/fixture.ab968851.png";